module.exports = __webpack_public_path__ + "img/SER-A-1-IV.0f1865c3.png";